<style>


    .c-product-view .gallery-wrap .img-big-wrap img {
        vertical-align: middle;
        display: inline-block;
    }

    .c-product-view .gallery-wrap .img-big-wrap {
        overflow: hidden;
        text-align: center;
        vertical-align: middle;
        height: 450px;
    }

    .c-product-view .gallery-wrap .img-small-wrap .item-gallery {
        width: 60px;
        height: 60px;
        border: 1px solid #ddd;
        margin: 7px 2px;
        display: inline-block;
        overflow: hidden;
    }

    .c-product-view .gallery-wrap .img-small-wrap {
        text-align: center;
    }

    .c-product-view .gallery-wrap .img-small-wrap img {
        max-width: 100%;
        max-height: 100%;
        object-fit: cover;
        border-radius: 4px;
        cursor: zoom-in;
    }
</style>

<template>
    <div class="c-product-view">
        <b-row>
            <b-col lg="5" class="border-right">
                <article class="gallery-wrap">
                    <div class="img-big-wrap">
                        <div><a href="#"><img :src="Core.Product.displayImage(dataProduct.image)"></a></div>
                    </div>
                    <div class="img-small-wrap">
                        <div class="item-gallery" v-for="image in images"><img :src="image.src"></div>
                    </div>
                </article>
            </b-col>
            <b-col lg="7">
                <article class="card-body p-5">
                    <h3 class="title mb-3">{{dataProduct.title}}</h3>

                    <p class="price-detail-wrap">
                            <span class="price h3">
                                {{Core.Currency.format(dataProduct.regularPrice)}}
                            </span>
                    </p>
                    <div class="item-property">
                        <div>{{Core.Definition.getDefinition('Description')}}</div>
                        <dd>
                            <p v-if="dataProduct.description === ''">{{dataProduct.shortDescription}}</p>
                            <p v-if="dataProduct.description !== ''" v-html="dataProduct.description"></p>
                            <p v-if="dataProduct.description === '' && dataProduct.shortDescription === ''">{{Core.Definition.getDefinition('Aucune description')}}</p>
                        </dd>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-sm-5">
                            <div class="param param-inline">
                                <InputQuantity :label="Core.Definition.getDefinition('Quantité')" v-model="dataProduct.quantity"></InputQuantity>
                            </div>
                        </div>
                        <div class="col-sm-7">
                        </div>
                    </div>
                    <hr>
                    <b-button-group>
                        <b-button @click="onPurchaseClick" class="btn btn-light">{{Core.Definition.getDefinition('Acheter maintenant')}}</b-button>
                        <b-button @click="onAddToCartClick" class="btn btn-light">{{Core.Definition.getDefinition('Ajouter au panier')}}</b-button>
                    </b-button-group>
                </article>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import InputQuantity from './InputQuantity'
    export default {
        name: 'ProductView',
        components: {
            InputQuantity
        },
        props: {
            value: {
                type: Object,
                default: function () {
                    return {}
                }
            }
        },
        watch: {
        },
        computed: {
            images() {
                let images = this.dataProduct.images
                if (images !== undefined) {
                    if (!Array.isArray(images)) {
                        images = JSON.parse(images)
                    }
                    if (!Array.isArray(images)) {
                        images = []
                    }
                    return images
                }
                return []
            }
        },
        mounted() {
            this.dataProduct = this.value
        },
        data: () => {
            return {
                Core: window.Core,
                dataProduct: {},
            }
        },
        methods: {
            onAddToCartClick() {
                this.$emit('onAddToCartClick', this.dataProduct)
            },
            onPurchaseClick() {
                this.$emit('onPurchaseClick', this.dataProduct)
            }
        }
    }
</script>
